import {
  Exact,
  InputMaybe,
  SecondChanceLeadFollowUpFilterInput,
  SecondChanceLeadsCountQuery,
} from '@api/generated/graphql';
import { QueryHookOptions, useLazyQuery } from '@apollo/client';
import appManager from '@app/appManager';
import AppModule from '@app/lib/AppModule';
import { getSecondChanceLeadsBadgeCountFilters } from '@pages/urgentfollowups/SecondChanceLeadsPage/utils/filters';
import { GET_SECOND_CHANCE_LEAD_CALL_FOLLOW_UPS_COUNT_QUERY } from './data/count';
import { frontEndSettingsState } from '@modules/FrontEndSettingsModule/state';

export type SecondChanceLeadsCountExecuteQueryOptions = QueryHookOptions<
  SecondChanceLeadsCountQuery,
  Exact<{
    filter?: InputMaybe<SecondChanceLeadFollowUpFilterInput>;
    take?: InputMaybe<number>;
  }>
>;

let executeQuery: (options?: SecondChanceLeadsCountExecuteQueryOptions) => void;

export function useSecondChanceLeadsCountQuery() {
  const [execute, queryResult] = useLazyQuery(
    GET_SECOND_CHANCE_LEAD_CALL_FOLLOW_UPS_COUNT_QUERY,
    { fetchPolicy: 'network-only' },
  );
  executeQuery = execute;

  return {
    error: queryResult.error,
    previousCount:
      queryResult.previousData?.secondChanceLeadFollowUps?.totalCount,
    currentCount: queryResult.data?.secondChanceLeadFollowUps?.totalCount,
    execute: (options?: QueryHookOptions<SecondChanceLeadsCountQuery>) => {
      execute(options);
    },
  };
}

class SecondChanceLeadsModule extends AppModule {
  override events = ['secondchancelead.update'];

  override preload(): void {
    if (executeQuery === undefined) {
      this.app.logger.warn(
        'SecondChanceLeadsModule: executeQuery is undefined, ensure useSecondChanceLeadsCountQuery is called before this module is used.',
      );
    }
    this.app.events.on('secondchancelead.update', () => {
      this.app.logger.info('trigger SCL refresh');

      const daysUntilCold =
        frontEndSettingsState.followUps.secondChanceLeads.daysUntilCold;
      executeQuery?.({
        variables: {
          filter: getSecondChanceLeadsBadgeCountFilters(daysUntilCold),
          take: 1,
        },
      });
    });
  }
}

export default new SecondChanceLeadsModule(
  appManager.events,
  appManager.logger('SecondChanceLeadsCount'),
);
